import {AfterViewInit, Component} from '@angular/core';
import {LocalStorageService} from '@services/local-storage.service';
import {SidebarService} from '@services/sidebar.service';
import {UserGuideService} from '@services/user-guide.service';
import {ClientManagementService} from '@services/client-management.service';
import {CLIENT, OTHER_THAN_CLIENT} from '@auth/constants';
import {LedgerSyncModalService} from '@shared/ledger-sync-modal/service.service';
import {CommonModule} from '@angular/common';
import { ClientHeaderComponent } from "./client-header/client-header.component";
import { HeaderComponent } from "./header/header.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { UserGuideComponent } from "../../user-guide/user-guide.component";
import { ToastComponent } from "../../toast/toast.component";
import { FdeLongPollingComponent } from "./fde-long-polling/fde-long-polling.component";
import { MfaComponent } from "./mfa/mfa.component";
import { RouterOutlet } from '@angular/router';
import {StackPanelHostComponent} from '@shared/stack-panel/stack-panel-host.component';
import {PdfConverterMonitorComponent} from './pdf-converter-monitor/pdf-converter-monitor.component';
import {UiSwitchService} from '@services/ui-switch.service';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    ClientHeaderComponent,
    HeaderComponent,
    SidebarComponent,
    UserGuideComponent,
    ToastComponent,
    FdeLongPollingComponent,
    MfaComponent,
    StackPanelHostComponent,
    PdfConverterMonitorComponent,
]
})
export class DefaultLayoutComponent implements AfterViewInit {
  isSidebarOpen = false;
  isSidebarCollapse = false;
  isClient: boolean = false;

  /**
   * change open and close sidebar for mobile version
   */
  onChangedSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  constructor(
    private localStorageService: LocalStorageService,
    private sidebarService: SidebarService,
    private userGuideService: UserGuideService,
    private clientManagementService: ClientManagementService,
    private ledgerSyncModalService: LedgerSyncModalService,
    private uiSwitchService: UiSwitchService,
  ) {
    this.sidebarService.collapseStatusHasChanged.subscribe((isLarge) => {
      if (!isLarge) {
        this.onChangedSidebar();
      }
    });
    this.isClient = this.localStorageService.getCurrentUserDetails().role === CLIENT;
    // if (!this.isClient) {
  //     this.ledgerSyncModalService.show({
  //       html: `<div class="f-size-12em text-center">
  // Manage all your bank rules and categorizations on one page for all your clients. A tool  that is far more superior than QBO.<br />
  // <a class="link" href="https://calendly.com/parkwayinc/ledgersync?back=1&month=2023-11" target="_blank">Set up</a> a time for a 1x1 demo and live test.
  // </div>`,
  //       dontShow: {
  //         dontShowAgain: true,
  //         dontShowAgainId: 'rules-engine-info-modal'
  //       }
  //     });
  //   }
  }

  ngAfterViewInit() {
    this.uiSwitchService.offerNewDesign(this.isClient);
    if (
      OTHER_THAN_CLIENT.includes(this.localStorageService.getCurrentUserDetails().role) &&
      !this.localStorageService.getSelectedClient()
    ) {
      this.clientManagementService.get()
      .subscribe((data) => {
        if (data.length < 2) {
          this.userGuideService.showGuide('ADD_CLIENT');
        }
      });
    }
  }

  /**
   *  change size sidebar
   * @param e - flag for small or big sidebar
   */
  onChanged(e) {
    this.isSidebarCollapse = e;
  }
}
